import React from 'react';
import { View } from 'react-native';
import { Divider } from 'react-native-elements';
import Checkbox from '@/components/ui/therapist/Checkbox';
import { Input } from '@/components/ui/therapist/Input';
import { NeolexonIcon } from '@/components/NeolexonIcon';
import { Text } from '@/components/Text';
import { FilterDrawer } from '@/components/ui/therapist/FilterDrawer';
import { styles } from './setFilter.styles';
import colors from '@/config/colors';

interface SetFilterProps {
  isOpen: boolean;
  onClose: () => void;
  drawerWidth?: number;
  resetFilter: () => void;
  typeFilter: ('WordSet' | 'SentenceSet' | 'TextSet')[];
  setTypeFilter: (
    value: 'WordSet' | 'SentenceSet' | 'TextSet',
    isSelected: boolean,
  ) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  applyFilter: () => void;
}

export const SetFilter: React.FC<SetFilterProps> = ({
  isOpen,
  onClose,
  drawerWidth,
  resetFilter,
  typeFilter,
  setTypeFilter,
  searchTerm,
  setSearchTerm,
  applyFilter,
}) => {
  return (
    <FilterDrawer
      isOpen={isOpen}
      onClose={onClose}
      onApply={applyFilter}
      onReset={resetFilter}
      drawerWidth={drawerWidth}
    >
      <View style={styles.section}>
        <Input
          label="Titel"
          value={searchTerm}
          onChange={setSearchTerm}
          iconLeft="magnifyingGlass"
        />
        <View style={styles.dividerSpacing}>
          <Divider width={1} color={colors.newUI.therapist.primaryBlue10} />
        </View>
      </View>
      <View style={styles.section}>
        <View>
          <Text style={styles.categoryLabel}>Kategorie</Text>
        </View>
        <View style={styles.categoryList}>
          <View style={styles.checkboxWrapper}>
            <Checkbox
              isSelected={typeFilter.includes('WordSet') || false}
              onPress={() =>
                setTypeFilter('WordSet', !typeFilter.includes('WordSet'))
              }
              label="Wörterset"
            />
            <NeolexonIcon name="letter" isInverted={false} size={20} />
          </View>
          <View style={styles.checkboxWrapper}>
            <Checkbox
              isSelected={typeFilter.includes('SentenceSet') || false}
              onPress={() =>
                setTypeFilter(
                  'SentenceSet',
                  !typeFilter.includes('SentenceSet'),
                )
              }
              label="Sätzeset"
            />
            <NeolexonIcon name="sentence" isInverted={false} size={20} />
          </View>
          <View style={styles.checkboxWrapper}>
            <Checkbox
              isSelected={typeFilter.includes('TextSet') || false}
              onPress={() =>
                setTypeFilter('TextSet', !typeFilter.includes('TextSet'))
              }
              label="Texteset"
            />
            <NeolexonIcon name="book" isInverted={false} size={20} />
          </View>
        </View>
        <View style={styles.dividerSpacing}>
          <Divider width={1} color={colors.newUI.therapist.primaryBlue10} />
        </View>
      </View>
    </FilterDrawer>
  );
};
